// eslint-disable-next-line
export const UPDATE_ALERT = 'UPDATE_ALERT';
export const SET_TOASTER = 'SET_TOASTER';
